module.exports = __webpack_public_path__ + "img/banner1.0827cb82.png";